import styled from 'styled-components';

export const SelectContainer = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  margin-bottom: 25px;
`;